/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TAA } from './tAA';
import { QuoteControl } from './quoteControl';

/**
 * This contains all relevant input data for price calculation. Further there are various quote control parameter,  which trigger additional price calculations.
 */
export interface MultiQuoteRequest {
  quote: TAA;
  quoteControl: QuoteControl;
}
